import { render, staticRenderFns } from "./SteamTradeOffer.vue?vue&type=template&id=5b2a83b2&"
import script from "./SteamTradeOffer.vue?vue&type=script&lang=ts&"
export * from "./SteamTradeOffer.vue?vue&type=script&lang=ts&"
import style0 from "./SteamTradeOffer.vue?vue&type=style&index=0&id=5b2a83b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QRating from 'quasar/src/components/rating/QRating.js';
import QSpace from 'quasar/src/components/space/QSpace.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QIcon,QLinearProgress,QBtn,QAvatar,QImg,QRating,QSpace});qInstall(component, 'directives', {ClosePopup});
